/** Shared look of the controls in the session settings dialog. */
export const settingsInputClass =
  'w-full px-3 py-2 bg-slate-800 border border-slate-700 rounded-md placeholder:text-slate-500 focus:outline-none focus:border-amber-600';

export const settingsButtonClass =
  'shrink-0 px-3 py-2 bg-amber-600 text-slate-100 rounded-md cursor-pointer hover:bg-amber-500 disabled:opacity-50 disabled:cursor-default disabled:hover:bg-amber-600';

export const settingsLabelClass = 'block mb-1 text-sm text-slate-300';

export const settingsMessageClass = 'text-sm text-amber-500';
